import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import Value from "aldoo-ra/Value"
import Export from "./Export"
import Import from "./Import"
import Deployment from "./Deployment"
const UpdatesHome = () => {
  const [updates] = Value("site-updates")

  return (
    <SidePanelLayout
      menuName="AdminUpdates"
      tabs={{
        deployment: Deployment,
        export: Export,
        import: Import,
      }}
      onMenuItemRender={(item) => {
        if (item.name !== "AdminDeployment") return null
        if (!updates) return null

        //show update badge when there are updates
        return (
          <div className="min-w-[20px] h-5 flex items-center justify-center rounded-full bg-admin_error text-white text-xs font-medium px-1.5">
            {updates > 99 ? "99+" : updates}
          </div>
        )
      }}
    />
  )
}

export default UpdatesHome
